import React from 'react';
import { isDev } from '../utils';
import { Alert, AlertTitle } from '@mui/material';
export function isGlueRestError(error) {
  var _a;

  if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) {
    let data = error.response.data;

    if (data.status && data.error && data.message) {
      return true;
    }
  }

  return false;
}
export function axiosErrorHandler(error) {
  if (error.response) {
    if (isDev) {
      console.error(error.response);
    }

    if (isGlueRestError(error)) {
      return error.response.data;
    } else if (!isDev) {
      //If error is not handle by GlueRestError, we log even in prod
      console.error(error.response);
    }
  } else if (error.request) {
    if (isDev) {
      console.error(error.request);
    } // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js

  } else {
    if (isDev) {
      console.error('Error', error.message);
    } // Something happened in setting up the request that triggered an Error

  }

  return undefined;
}

function isNetworkError(error) {
  if (error) {
    return error.isAxiosError !== undefined;
  } else {
    return false;
  }
}

export class AxiosErrorBoundary extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {};
  }

  static getDerivedStateFromError(error) {
    if (isNetworkError(error)) {
      return {
        error: error
      };
    } else {
      throw error;
    }
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    } else {
      return React.createElement(this.props.fallbackComponent, {
        error: this.state.error
      });
    }
  }

}
AxiosErrorBoundary.defaultProps = {
  fallbackComponent: _ref => {
    let {
      error
    } = _ref;

    var _a, _b, _c;

    let glueError = axiosErrorHandler(error);
    return React.createElement(Alert, {
      variant: "outlined",
      severity: "error",
      style: {
        margin: '20px'
      }
    }, React.createElement(AlertTitle, null, "Error ", (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 'Undefined', ' ', (glueError === null || glueError === void 0 ? void 0 : glueError.message) ? ' - ' + glueError.message : ''), (_c = glueError === null || glueError === void 0 ? void 0 : glueError.message) !== null && _c !== void 0 ? _c : 'Erreur inconnue ' + error.message);
  }
};